import type { ReactNode } from 'react';
import { EstadoError } from '@xiltrion/ui/bloques/estados';
import { useSession } from '@/app/session';

export function ModuleGuard({ module, children }: { module: string; children: ReactNode }) {
  const { has } = useSession();
  return has(module) ? <>{children}</> : <div className="p-6"><EstadoError titulo="Esta función no está activa en tu organización." /></div>;
}
